export enum JobSortType {
  StartDate = 1,
  MostRecentPost = 2,
  WeeklyPay = 3,
  Recommended = 4,
}
